import { useState, useEffect } from "react";
import {
  Autocomplete,
  DatePicker,
  Divider,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../../components";
import { responseErros } from "../../../../utils";
import { value } from "../../../../helpers";
import { BancosCaixasService, SessionService } from "../../../../services";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const FormFiltroAvancadoCaixa = ({
  filtrosAvancados,
  setFiltrosAvancados,
  setFiltrosAplicadosImpressao,
  setValidationError,
}) => {
  const sessionService = new SessionService();
  const { usuario, empresa } = sessionService.getEmpresaAndUsuario();

  const bancosCaixasService = new BancosCaixasService();
  const [contaLista, setContaLista] = useState([]);
  const { onChangeAutocomplete, onChangeDate } = useFiltrosRelatoriosHandlers(
    setFiltrosAvancados,
    setFiltrosAplicadosImpressao,
  );

  const buscaContas = (filtros) => {
    const filtro = {
      ...filtros,
      ativado: true,
      limite: 20,
    };
    bancosCaixasService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        if (result.data?.rows) {
          setContaLista(result.data?.rows);
        }
      } else {
        responseErros(result);
      }
    });
  };

  function onChangeMultipleEmpresas(empresas) {
    if (empresas.length === 0) {
      return;
    }
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  useEffect(() => {
    buscaContas({});
    setEstadoInicial();
  }, []);

  function setEstadoInicial() {
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: [empresa.id],
    }));
    if (usuario.acessosEmpresas?.length) {
      setFiltrosAplicadosImpressao((prevState) => ({
        ...prevState,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      }));
    }
  }

  return (
    <>
      {usuario.acessosEmpresas?.length > 0 && (
        <>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                id="empresasIds"
                name="empresasIds"
                options={usuario.acessosEmpresas}
                noOptionsText="Sem opções"
                autoHighlight
                disablePortal
                filterSelectedOptions
                getOptionLabel={(option) => option?.razaoSocial || ""}
                onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
                value={value.multiple(
                  usuario.acessosEmpresas || [],
                  filtrosAvancados["empresasIds"]
                    ? filtrosAvancados["empresasIds"]
                    : "",
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    required
                    label="Empresas"
                    margin="normal"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }} />
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            id="periodoStart"
            name="Período-De"
            label="Período de"
            format="dd/MM/yyyy"
            margin="normal"
            value={value.date(filtrosAvancados.periodoStart)}
            onChange={(date) =>
              onChangeDate("periodoStart", date, "Período-De")
            }
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            id="periodoEnd"
            name="Período-Até"
            label="Período Até"
            format="dd/MM/yyyy"
            margin="normal"
            value={value.date(filtrosAvancados.periodoEnd)}
            onChange={(date) => onChangeDate("periodoEnd", date, "Período-Até")}
            slotProps={{
              popper: { sx: { zIndex: 2000 } },
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Autocomplete
            id="bancoCaixaId"
            name="Banco-Caixa"
            options={contaLista}
            noOptionsText="Sem opções"
            autoHighlight
            disablePortal
            getOptionLabel={(option) => (option.nome ? option.nome : "")}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                label="Conta"
                margin="normal"
                variant="outlined"
              />
            )}
            onChange={(_e, value) =>
              onChangeAutocomplete("bancoCaixaId", value, "Banco-Caixa")
            }
            value={value.autoComplete(
              contaLista,
              filtrosAvancados?.bancoCaixaId,
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Select
            label="Ordenar Por"
            id="ordenacao"
            name="ordenacao"
            variant="outlined"
            value={value.text(filtrosAvancados?.ordenacao)}
            onChange={(event) => {
              setFiltrosAvancados({
                ...filtrosAvancados,
                [event.target.name]: event.target.value ?? null,
              });
            }}
            SelectProps={{
              MenuProps: {
                disablePortal: true,
                PaperProps: {
                  sx: {
                    zIndex: 1600,
                  },
                },
              },
            }}
          >
            <MenuItem value="data">Data</MenuItem>
            <MenuItem value="tipoPagamento">Tipo de Pagamento</MenuItem>
            <MenuItem value="tipo">Tipo (Entrada-Saída-Ret.Baixa)</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </>
  );
};

export default FormFiltroAvancadoCaixa;
